import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import { constantsApiEndpoints } from "../../../api";
import { toast } from "sonner";

// State that the response will be put into
const initialState = {
  blocksAndAreas: null,
  isLoading: false,
  success: false,
  error: null,
};

// Async API call with Axios timeout
export const fetchBlocksAndAreasList = createAsyncThunk(
  "fetchBlocksAndAreasList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`${constantsApiEndpoints.blocksAndAreas}`, null, {
        timeout: 30000, // Set timeout to 30 seconds
      });
      return response.data;
    } catch (error) {
      console.error("Blocks and areas API error:", error);
      if (error.code === 'ECONNABORTED') {
        // Handle timeout specific error
        toast.error('Request timed out');
        return rejectWithValue('Request timed out');
      }
      toast.error(error.response?.data || 'An error occurred');
      return rejectWithValue(error.response?.data || error.message || 'An error occurred');
    }
  }
);

// Redux slice that contains the reducers/action calls
export const blocksAndAreasListSlice = createSlice({
  name: "Get Blocks And Areas List",
  initialState,
  reducers: {
    clearBlocksAndAreasListError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // FETCH BLOCKS AND AREAS API
    builder.addCase(fetchBlocksAndAreasList.pending, (state, action) => {
      if (!state.blocksAndAreas) {
        state.isLoading = true;
        state.success = false;
      }
    });
    builder.addCase(fetchBlocksAndAreasList.fulfilled, (state, action) => {
      state.success = true;
      state.isLoading = false;
      state.error = null;
      state.blocksAndAreas = action.payload;
    });
    builder.addCase(fetchBlocksAndAreasList.rejected, (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.error?.message;
    });
  },
});

// SELECTORS which can be easily called to get the corresponding value
export const selectBlocksAndAreas = (store) => store.blocksAndAreasList?.blocksAndAreas;
export const selectBlocksAndAreasLoader = (store) => store?.blocksAndAreasList?.isLoading;
export const selectBlocksAndAreasSuccess = (store) => store?.blocksAndAreasList?.success;

// ACTIONS TO DISPATCH
export const { clearBlocksAndAreasListError } = blocksAndAreasListSlice.actions;

export default blocksAndAreasListSlice.reducer;